export const cTitleSlug = "titulo"
export const cDescritionSlug = "descricao"
export const cStatusSlug = "status"
export const cCalcSlug = "campo-calculo"
export const cDeadLineSlug = "prazo"
export const dConclusionDateSlug = "data_de_conclusao"
export const dCreationDateSlug = "data_de_criacao"
export const cResponsiblesSlug = "act_responsibles"
export const cInvolvedsSlug = "act_involveds"

export const cStatusFieldName = "status-value"
